export default __webpack_public_path__ + "static/media/success.7dfd5884.png";